import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Container, Header, Segment, Grid, Card, Message, Divider, List, Step } from 'semantic-ui-react';
import '../Playbook.css';

class PlanYourInteractions extends Component {
    render() {
        return (
            <Container fluid className="playbook-container">
                <h1 className="ui icon center aligned header playbook-branded-header" style={{fontFamily: 'Montserrat', textTransform: 'uppercase', color: 'rgb(35, 37, 58)', fontWeight: 600, fontSize: '38px', marginBottom: '-9px'}}>
                    <i aria-hidden="true" className="icon">
                        <img src="/static/media/logo-icon.7bb8994723bbdcd674f1.png" alt="logo-icon" style={{height: '68px', marginBottom: '-15px'}} />
                    </i>
                    Sales Activity
                </h1>
                <div className="ui divider"></div>

                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment className="playbook-content">
                                <Header as="h2" className="section-header">Intentionality</Header>
                                
                                <p>
                                    When we talk about being intentional, we mean having a plan for every single encounter. That involves being very prepared and knowing:
                                </p>

                                <Grid stackable>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Step.Group fluid stackable="tablet">
                                                <Step>
                                                    <Step.Content>
                                                        <Step.Title>Question 1</Step.Title>
                                                        <Step.Description>What are we going to say?</Step.Description>
                                                    </Step.Content>
                                                </Step>
                                                
                                                <Step>
                                                    <Step.Content>
                                                        <Step.Title>Question 2</Step.Title>
                                                        <Step.Description>What are we going to ask for?</Step.Description>
                                                    </Step.Content>
                                                </Step>
                                                
                                                <Step>
                                                    <Step.Content>
                                                        <Step.Title>Question 3</Step.Title>
                                                        <Step.Description>What do we want the desired next step to be?</Step.Description>
                                                    </Step.Content>
                                                </Step>
                                            </Step.Group>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                
                                <p style={{marginTop: '20px'}}>
                                    You need to be able to answer these 3 questions when doing cold outreach, meeting a prospect for the 1st time, networking, or having a secondary meeting around a problem.
                                </p>

                                <p>
                                    Here is our "cheat sheet" to help you remember what you are trying to accomplish in each setting.
                                </p>

                                <Divider />

                                <div style={{textAlign: 'center', margin: '20px 0'}}>
                                    <img 
                                        src="/downloads/sales-process.png" 
                                        alt="Sales Process Cheat Sheet" 
                                        style={{
                                            maxWidth: '100%', 
                                            height: 'auto', 
                                            border: '1px solid #ddd', 
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                        }} 
                                    />
                                </div>

                                <Divider />

                                <Message info>
                                    <Message.Header>Key Implementation</Message.Header>
                                    <p>
                                        Use this visual guide to prepare for every sales interaction. Having clear answers to these three questions 
                                        will help you maintain control of the conversation and advance the sales process effectively.
                                    </p>
                                </Message>

                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

export default observer(PlanYourInteractions);